import { render, staticRenderFns } from "./PerformanceRegiao.vue?vue&type=template&id=5e45b824"
import script from "./PerformanceRegiao.vue?vue&type=script&lang=js"
export * from "./PerformanceRegiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports